"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { LuLink } from "react-icons/lu";
import { Button } from "@/components/ui";
import Input from "@/components/ui/input";
import { cx } from "@/lib/tailwind-utils";

/** Resolves once the browser has loaded (or failed to load) the image. */
function loadsAsImage(url: string): Promise<boolean> {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/**
 * "Paste an image link" — for images already hosted somewhere (a website, a
 * Canva share, a CDN) instead of uploading a file.
 *
 * The link is checked by loading it first, so a typo or a web page address
 * is caught here rather than arriving as a broken image in someone's inbox.
 * Not a `<form>`: the composer can sit inside one, and forms don't nest.
 */
export function ImageUrlForm(t0) {
  const $ = _c(29);
  const {
    onSubmit,
    className
  } = t0;
  const [url, setUrl] = useState("");
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== onSubmit || $[1] !== url) {
    t1 = async () => {
      const link = url.trim();
      if (!/^https?:\/\/\S+$/i.test(link)) {
        setError("Paste a link that starts with https://");
        return;
      }
      setChecking(true);
      const ok = await loadsAsImage(link);
      setChecking(false);
      if (!ok) {
        setError("That link didn't open as an image");
        return;
      }
      setError("");
      setUrl("");
      onSubmit(link);
    };
    $[0] = onSubmit;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const submit = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cx("flex items-start gap-1.5", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      setUrl(e.target.value);
      setError("");
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== submit) {
    t4 = e_0 => {
      if (e_0.key === "Enter") {
        e_0.preventDefault();
        submit();
      }
    };
    $[6] = submit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !!error;
  let t6;
  if ($[8] !== error || $[9] !== t4 || $[10] !== t5 || $[11] !== url) {
    t6 = <Input value={url} onChange={t3} onKeyDown={t4} placeholder={"Paste an image link (https://\u2026)"} aria-label="Image link" hasError={t5} errorMessage={error} className="h-8 text-caption" />;
    $[8] = error;
    $[9] = t4;
    $[10] = t5;
    $[11] = url;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== checking || $[14] !== url) {
    t7 = checking || !url.trim();
    $[13] = checking;
    $[14] = url;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== submit) {
    t8 = () => void submit();
    $[16] = submit;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LuLink size={14} />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = checking ? "Checking\u2026" : "Use link";
  let t11;
  if ($[19] !== t10) {
    t11 = <span>{t10}</span>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t7 || $[23] !== t8) {
    t12 = <Button type="button" variant="primary" size="sm" disabled={t7} onClick={t8}>{t9}{t11}</Button>;
    $[21] = t11;
    $[22] = t7;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t2 || $[27] !== t6) {
    t13 = <div data-editor-field={true} className={t2}>{t6}{t12}</div>;
    $[25] = t12;
    $[26] = t2;
    $[27] = t6;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}